<div class="modal-header">
  <h5 class="modal-title">
    <div *ngIf="!repository.id"><i class='bx bx-folder-open'></i> Nova pasta</div>
    <div *ngIf="repository.id"><i class='bx bx-folder-open'></i> Editar pasta</div>
    <p>Informe os dados do seu projeto.</p>
  </h5>
  <div>
    <a (click)="activeModal.dismiss()">
      <i class='bx bx-x'></i>
    </a>
  </div>
</div>

<div [formGroup]="form">
  <div class="modal-body" id="accordionRepo">
    <div class="d-flex justify-content-center align-items-center row">
      <div class="col-md-12 form-group">
        <label for="name">Nome:</label>
        <input type="text" formControlName="name" class="form-control" id="name"
          placeholder="Digite aqui o nome do projeto" minlength="10" [ngClass]="{
            'is-invalid':
              submitted &&
              (form.get('name').hasError('required') ||
                form.get('name').hasError('minlength'))
          }" />
        <div class="invalid-feedback">
          <small *ngIf="form.get('name').hasError('required')">Nome não foi informado</small>
          <small *ngIf="form.get('name').hasError('minlength')">Nome deve possuir pelo menos 10 caracteres</small>
        </div>
      </div>

      <div class="col-md-12 form-group">
        <label for="description">Descrição:</label>
        <input type="text" formControlName="description" class="form-control" id="description"
          placeholder="Digite aqui a descrição do projeto" minlength="10" [ngClass]="{
            'is-invalid':
              submitted &&
              (form.get('description').hasError('required') ||
                form.get('description').hasError('minlength'))
          }" />
        <div class="invalid-feedback">
          <small *ngIf="form.get('description').hasError('required')">Descrição não foi informado</small>
          <small *ngIf="form.get('description').hasError('minlength')">Descrição deve possuir pelo menos 10
            caracteres</small>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="hasProjects()">
      <!-- <div class="col">
        <mat-form-field>
          <mat-label>Projetos</mat-label>
          <mat-select multiple matNativeControl
          [(ngModel)]="selectedProjects"
          [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let project of projects" [value]="project.id">{{ project.title }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
      <div class="col">
        <mat-form-field class="chip-list">
          <mat-label>Projetos</mat-label>
          <mat-chip-list #chipList aria-label="Selecionar projetos">
            <mat-chip *ngFor="let project of selectedProjects" [selectable]="selectable" [removable]="removable"
              (removed)="remove(project)">
              {{ project.title | uppercase }}
              <mat-icon matChipRemove *ngIf="removable">cancelar</mat-icon>
            </mat-chip>
            <input placeholder="Novo projeto" #projectInput [formControl]="projectCtrl" [matAutocomplete]="auto"
              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <ng-container *ngFor="let project of filteredProjects | async">
              <mat-option *ngIf="!hasIncluded(project)" [value]="project">
                {{ project.title | uppercase }}
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="button button-cancel w-50" (click)="activeModal.dismiss()">
      Voltar
    </button>
    <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader class="button button-primary w-50"
      joyrideStep="firstStep" stepPosition="bottom" title="Salve sua pasta"
      text="Preencha o nome da pasta e a descrição (no mínimo com 10 caracteres) e clique em salvar.">
      Salvar
    </button>
  </div>
</div>